import styled from 'styled-components/macro'
import Box from 'components/shared/Box'
import { respondAbove } from 'styles/mediaQueries'

export const AmenitiesListWrapper = styled(Box)`
    @media ${respondAbove.xl} {
        max-height: 274px;
        column-gap: 46px;
        > div {
            max-width: 330px;
            &:nth-child(7) {
                margin-top: 0 !important;
            }
        }
    }
`

export const AdditionalServices = styled(Box)`
    @media ${respondAbove.xl} {
        max-height: 260px;
        column-gap: 32px;
        > div {
            max-width: 330px;
            &:nth-child(5) {
                margin-top: 0 !important;
            }
        }
    }
`

export const AccommodationModalBody = styled(Box)`
    background: ${({ theme }) => theme.colors.grayscale_200};
    border-radius: 0 0 8px 8px;
`
